import * as React from 'react';
import { useCallback } from 'react';
import { useRoutes } from '../../../navigation/routes';
import { useAppState } from '../../../core/redux/hooks';
import { Redirect, Route, RouteProps, RouteComponentProps } from 'react-router-dom';
import { PAGE_BG, PAGE_HEIGHT } from '../../../layout/pageStyle';
import { FLEX_COLUMN, FLEX_CENTERED } from '../../../layout/flexBox';
import { Spinner } from '../../../loading/Spinner';
import { COLORS } from '../../../globalStyle/colors';
import { css } from '@emotion/core';
import { useCurrentCollaborator } from './hooks';


const styles = {
  spinner: css`
    width: 100px;
    height: 100px;
  `,
};


interface Props extends RouteProps {
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  path: string;
}


/**
 * CollaboratorRoute: a component that renders the requested route, when the user is a dev plan collaborator, otherwise
 * redirects the user to project login
 */
const CollaboratorRoute: React.FC<Props> = props => {
  const isCollaborator = !!useCurrentCollaborator();
  const routes         = useRoutes();

  const sessionStorageLoaded = useAppState(state => state.sessionStorageLoaded);

  const { component, ...rest } = props;

  const renderFunc = useCallback(
    (routeProps: any) => isCollaborator
      ? <props.component {...routeProps} />
      : <Redirect
        to={{
          pathname: routes.Login,
          state:    {
            from: routeProps.location,
            at:   new Date(),
          },
        }}
      />,
    // Eslint apparently doesn't see JSX tags as a usage...
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isCollaborator, props.component],
  );

  return sessionStorageLoaded
    ? <Route {...rest} render={renderFunc} />
    : (
      <div css={[PAGE_BG, PAGE_HEIGHT, FLEX_COLUMN, FLEX_CENTERED]}>
        <Spinner fill={COLORS.GREEN} css={styles.spinner} />
      </div>
    );
};

export default CollaboratorRoute;
